<template>
  <div id="couponclasslist">
    <article-head></article-head>
    <h2 class="title">
      <router-link :to="{name: 'MyCoupon'}" class="prev"></router-link>
      当前优惠券可用课程
    </h2>
    <div class="main">
      <div class="course1" v-for="(item2, index2) in course1Data" :key="index2" @click="jumpUrl(item2.class_id, item2.jump_type, item2.signup)">
        <div class="left">
          <img :src="item2.class_app_img_1"  alt="">
        </div>
        <div class="right">
          <h4>{{item2.class_name}}</h4>
          <p class="detail">{{item2.class_name_main}}</p>
          <div v-if="item2.class_label">
            <span v-for="(item3, index3) in item2.class_label_details" :key="index3" :style="{'border-color': item3.label_bg_color ? item3.label_bg_color : '#000', 'color': item3.label_color ? item3.label_color : '#000'}" v-if="item3">
              {{item3.label_name}}
            </span>
          </div>
          <p class="people">{{item2.class_sum_price}}人报名</p>
          <b class="price" v-if="parseInt(item2.section_price + item2.section_price_decimal) === 0">0元</b>
          <b class="price" v-else>¥<span>{{item2.section_price}}</span>{{item2.section_price_decimal}}</b>
          <a class="bmst" v-if="item2.signup">去听课</a>
          <a class="bmst" v-else>查看课程</a>
        </div>
      </div>
    </div>
    <article-foot></article-foot>
  </div>
</template>

<script>
import articleHead from '../share/header/articleHead'
import articleFoot from '../share/footer/articleFoot'
export default {
  name: 'CouponClassList',
  components: {
    articleHead,
    articleFoot
  },
  data () {
    return {
      pageName: 'CouponClassList',
      vouchersId: this.$route.query.vouchers_id ? this.$route.query.vouchers_id : 5,
      course1Data: {}
    }
  },
  methods: {
    // 获得课程一数据
    getCourse1 () {
      let data = {
        vouchers_id: this.vouchersId
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_vouchers_use',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log('课程列表：')
          console.log(res)
          this.course1Data = res.data.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    jumpUrl (classId, jumpType, signUp) {
      switch (jumpType) {
        case 0: // 0 不跳转
          event.preventDefault()
          break
        case 1: // 1 h5连接[资讯]
          this.$router.push(classId)
          break
        case 2: // 2 课程列表【合集id】 暂时用不到
          if (signUp) {
            this.$router.push({name: 'VideoPlay', query: {class_id: classId}})
          } else {
            this.$router.push({name: 'ClassDetailTeacher', query: {class_id: classId}})
          }
          break
        case 3: // 3 班级详情【班级id】
          if (signUp) {
            this.$router.push({name: 'VideoPlay', query: {class_id: classId}})
          } else {
            this.$router.push({name: 'ClassDetailTeacher', query: {class_id: classId}})
          }
          break
        case 4: // 4 h5连接[活动]
          this.$router.push(classId)
          break
        case 11:
          this.easyChat()
          break
      }
    }
  },
  mounted () {
    this.getCourse1()
  }
}
</script>

<style scoped lang="stylus">
  #couponclasslist
    @import "../../assets/stylus/examHead"
    .main
      background-color: #F9F9F9
      padding: 0 .2rem
      overflow: hidden
      .course1
        position: relative
        display: flex
        justify-content: space-between
        border-top: .2rem solid transparent
        border-bottom: .2rem solid transparent
        &::after
          content: ""
          position: absolute
          bottom: -.2rem
          left: -.2rem
          display: block
          width: 7.5rem
          height: .02rem
          background-color: #D7D7D7
        &:last-child::after
          display: none
        .left
          overflow: hidden
          width: 3.2rem
          height: 3.2rem
          img
            width: 100%
        .right
          position: relative
          width: 3.7rem
          height: 3.2rem
          h4
            overflow: hidden
            /*white-space: nowrap*/
            text-overflow: ellipsis
            font-size: .32rem
            color: #0C0C0C
            font-weight: bold
            text-align: left
          p
            overflow: hidden
            margin: .04rem 0
            /*white-space: nowrap*/
            text-overflow: ellipsis
            color: #9DA4B3
            &.detail
              font-size: .24rem
            &.people
              display: none
              font-size: .22rem
          & > div
            margin: .14rem 0
            span
              display: inline-block
              padding: .02rem .04rem
              border: .01rem solid #FF7052
              margin: 0 .05rem .05rem 0
              font-size: .22rem
              color: #FF7052
              -webkit-border-radius: .04rem
              -moz-border-radius: .04rem
              border-radius: .04rem
          b.price
            position: absolute
            bottom: 0
            left: 0
            display: block
            margin-top: .14rem
            font-size: .3rem
            color: #FF7052
            font-weight: 500
            span
              font-size: .4rem
              font-weight: 600
          a.bmst
            position: absolute
            bottom: 0
            right: 0
            display: block
            width: 1.52rem
            height: .56rem
            line-height: .56rem
            background-color: #FF7052
            font-size: .24rem
            color: #fff
            text-align: center
            -webkit-border-radius: .34rem
            -moz-border-radius: .34rem
            border-radius: .34rem
    >>> #articlefoot > .main
      margin-top: 0
</style>



// WEBPACK FOOTER //
// src/components/class/CouponClassList.vue